<script setup>
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const store = useStore();
const { t } = useI18n();

const settings = computed(
  () => store.getters['painel/getPainelSettings'] || {}
);
const start = ref(settings.value?.business_hours?.start || '08:00');
const end = ref(settings.value?.business_hours?.end || '20:00');
const apiMinLeadHours = ref(Number(settings.value?.api_min_lead_hours ?? 0));

watch(settings, v => {
  start.value = v?.business_hours?.start || '08:00';
  end.value = v?.business_hours?.end || '20:00';
  apiMinLeadHours.value = Number(v?.api_min_lead_hours ?? 0);
});

const save = async () => {
  await store.dispatch('painel/updateSettings', {
    business_hours: { start: start.value, end: end.value },
    api_min_lead_hours: Math.max(0, Number(apiMinLeadHours.value) || 0),
  });
};
</script>

<template>
  <div class="max-w-md space-y-3">
    <label class="block">
      <span class="text-xs uppercase text-n-slate-11">
        {{ t('PAINEL.APPOINTMENTS.SETTINGS.BUSINESS_HOURS_START') }}
      </span>
      <input
        v-model="start"
        type="time"
        class="mt-1 rounded border border-n-strong bg-n-surface-1 px-2 py-1"
      />
    </label>
    <label class="block">
      <span class="text-xs uppercase text-n-slate-11">
        {{ t('PAINEL.APPOINTMENTS.SETTINGS.BUSINESS_HOURS_END') }}
      </span>
      <input
        v-model="end"
        type="time"
        class="mt-1 rounded border border-n-strong bg-n-surface-1 px-2 py-1"
      />
    </label>
    <label class="block pt-3">
      <span class="text-xs uppercase text-n-slate-11">
        {{ t('PAINEL.APPOINTMENTS.SETTINGS.API_MIN_LEAD_HOURS_LABEL') }}
      </span>
      <input
        v-model.number="apiMinLeadHours"
        type="number"
        min="0"
        step="1"
        class="mt-1 w-32 rounded border border-n-strong bg-n-surface-1 px-2 py-1"
      />
      <span class="mt-1 block text-xs text-n-slate-11">
        {{ t('PAINEL.APPOINTMENTS.SETTINGS.API_MIN_LEAD_HOURS_HELPER') }}
      </span>
    </label>
    <button
      class="rounded bg-n-brand px-4 py-2 text-sm font-semibold text-white"
      @click="save"
    >
      {{ t('PAINEL.STATUS_CUSTOMIZATION.SAVE') }}
    </button>
  </div>
</template>
